import Vue from 'vue';

export default {
    state:{
      tareas:{
       
      }
    },
    mutations: {
      
    },
    actions: { 
      postCSS({ }, payload) {
        try {
          $("#" + payload.id)
            .append(
              `<style>${payload.style}</style>`
            );
        } catch (error) {
  
        }
      },
    },
    getters: {  
      
    },
    
}


// WEBPACK FOOTER //
// C:/Users/cesar/Documents/dev/LMSEDK/LMSDEKTernium-clone/D:/dev/LMSEDK/LMSDEKTernium-clone/src/modules/tareas.js